import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BlueButton } from '../blue-button';
import { MY_VC_ACCOUNT_LINK } from 'src/constants/index';
import './style.scss';

interface IProps {}

export class Membership extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return (
      <div className="membership">
        <div className="membership__wrapper">
          <div className="membership__text">
            <p className="membership__title">
              <FormattedMessage id="renew.my.membership" />
            </p>
            <p className="membership__description">
              <FormattedMessage id="need.to.book.trip.and.think.my.membership.expired" />
            </p>
          </div>
          <a
            href={MY_VC_ACCOUNT_LINK}
            className="membership__btn-wrapper"
            target="_blank"
            rel="noreferrer"
          >
            <BlueButton>
              <FormattedMessage id="renew.membership" />
            </BlueButton>
          </a>
        </div>
      </div>
    );
  }
}
